import BlankLayout from "layout/BlankLayout";
import aboutPic from "../images/about-pic.svg";
const About = () => {
  return (
    <BlankLayout>
      <>
        <div className="section">
          <div className="container">
            <div className="w-layout-grid about-intro-grid">
              <div
                id="w-node-_9b2922ad-09b1-aebb-0430-7dee623c62c1-21047192"
                className="about-head-text-wrap"
              >
                <h2 className="hi-there-heading">About The Study</h2>
                <p className="paragraph-light">
                  I’m a web and graphic designer based in San Francisco, CA. I’m
                  originally from Brooklyn, NY and will forever talk about the
                  superiority of New York pizza and bagels. I like to build for
                  the web and make things pretty.
                </p>
              </div>
              <img
                src={aboutPic}
                id="w-node-_9b2922ad-09b1-aebb-0430-7dee623c62c8-21047192"
                alt=""
              />
            </div>
          </div>
        </div>
        <div className="section">
          <div className="container"></div>
          <div className="container">
            <div className="social-media-heading">
              <h3>About Smart Girls HQ</h3>
              <p className="paragraph-light">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                Suspendisse varius enim in eros elementum tristique. Duis
                cursus, mi quis viverra ornare, eros dolor interdum nulla.
              </p>
            </div>
          </div>
        </div>
        <div className="section"></div>
      </>
    </BlankLayout>
  );
};

export default About;
